module.exports = {"ru":{"isEmpty":"Вы не посетили ни одной страницы","toMainPage":"Перейти на главную","clean":"Очистить историю","clearedText":"История очищена"},"en":{"isEmpty":"You haven't visited any of the web pages of this website","toMainPage":"Please visit our homepage","clean":"Clean history","clearedText":"History is cleared"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/history/.variant/base/text.yaml
// module id = 117
// module chunks = 0